import React, { useState, useEffect } from "react";
import {
  Card,
  List,
  Typography,
  Tag,
  Spin,
  Alert,
  Space,
  Button,
  Row,
  Col,
  Tabs,
  Avatar,
  Pagination,
  Select,
  Empty,
  Descriptions,
  Modal,
  Popover
} from "antd";
import {
  EyeOutlined,
  EditOutlined,
  PlusOutlined,
  UserOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
  ClockCircleOutlined,
  LinkedinOutlined,
  StarFilled,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import useCourses from "../Hooks/Courses/useCourseList";

const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

const CoursesList = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("all");
  const [expandedCourseId, setExpandedCourseId] = useState(null);

   // Price Modal State
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedPriceData, setSelectedPriceData] = useState(null);

  // Convert tab to isPublished parameter for API
  const getIsPublishedParam = (tab) => {
    switch(tab) {
      case "published":
        return true;
      case "draft":
        return false;
      default:
        return undefined; // "all" tab - get all courses
    }
  };
const handleCompleteSetupClick = (courseId) => {
    navigate(`/proAdmin-dashboard/courseDetails/${courseId}`);
  };

  const handleCardClick = (courseId) => {
    navigate(`/proAdmin-dashboard/courses/${courseId}`);
  };

  const formatTime = (timeString) => {
  if (!timeString || timeString === "00:00:00") return "Not specified";
  const [hours, minutes] = timeString.split(":").map(Number);
  if (hours === 0) return `${minutes}m`;
  return `${hours}h ${minutes}m`;
};


  const handleCourseCardClick = (course) => {
  if (course.isPublished) {
    handleCardClick(course.id);          // Published → View course
  } else {
    handleCompleteSetupClick(course.id); // Draft → Complete setup
  }
};


  const { 
    courses = [], 
    loading, 
    error, 
    pagination = {
      currentPage: 1,
      pageSize: 9,
      totalCount: 0,
      totalPages: 0,
      orderByLatest: true
    },
    handlePageChange, 
    handlePageSizeChange,
    handleSortChange,
    handleFilterChange,
    refetch
  } = useCourses();
  console.log("////////////////////////courses is admin",courses);

  // Initialize with current tab filter
  useEffect(() => {
    const isPublishedParam = getIsPublishedParam(activeTab);
    handleFilterChange(isPublishedParam);
  }, []);

  // Handle tab change - server-side filtering
  const handleTabChange = (key) => {
    setActiveTab(key);
    const isPublishedParam = getIsPublishedParam(key);
    handleFilterChange(isPublishedParam);
  };

   // Get author name from course object
  const getAuthorName = (course) => {
    if (course.authorName) {
      return course.authorName;
    }
    return "Unknown Author";
  };

   // Get LinkedIn URL from course object
  const getLinkedInUrl = (course) => {
    if (course.authorLinkedIn) {
      return course.authorLinkedIn;
    }
    return null;
  };

  // Logic to convert days to readable Y/M/D
  const formatDuration = (totalDays) => {
    if (!totalDays) return "Not specified";
    const years = Math.floor(totalDays / 365);
    const months = Math.floor((totalDays % 365) / 30);
    const days = (totalDays % 365) % 30;

    const parts = [];
    if (years > 0) parts.push(`${years} ${years === 1 ? 'Year' : 'Years'}`);
    if (months > 0) parts.push(`${months} ${months === 1 ? 'Month' : 'Months'}`);
    if (days > 0) parts.push(`${days} ${days === 1 ? 'Day' : 'Days'}`);
    return parts.join(", ");
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Error Loading Courses"
        description={error}
        type="error"
        showIcon
        style={{ margin: "20px" }}
      />
    );
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  };

  const openPriceModal = (e, course) => {
    e.stopPropagation(); // Prevents navigating to course details
    setSelectedPriceData(course);
    setIsModalVisible(true);
  };

  

  

  

  

  const handleCreateNewCourse = () => {
    navigate("/proAdmin-dashboard/courses/create");
  };

 

  // Handle pagination change
  const onPageChange = (page, size) => {
    if (size !== pagination.pageSize) {
      handlePageSizeChange(size);
    } else {
      handlePageChange(page);
    }
  };

  // Handle sort change
const onSortChange = (value) => {
  console.log("************UI SORT SELECTED:", value); 
  handleSortChange(value === 'latest');
};



  // Calculate showing range - CORRECT for current tab
  const getShowingRange = () => {
    const start = ((pagination.currentPage - 1) * pagination.pageSize) + 1;
    const end = Math.min(pagination.currentPage * pagination.pageSize, pagination.totalCount);
    return { start, end };
  };

  const { start, end } = getShowingRange();

  // Get tab display text
  const getTabDisplayText = () => {
    switch(activeTab) {
      case "published":
        return "Published Courses";
      case "draft":
        return "Draft Courses";
      default:
        return "All Courses";
    }
  };

  return (
    <div style={{
padding: window.innerWidth < 768 ? "12px" : "24px",
   maxWidth: "1400px",
  margin: "0 auto"
}}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        {/* Header with Create Button */}
    <Row
  justify="space-between"
  align="middle"
  style={{ marginBottom: 16 }}
>
  <Col>
    <Title level={2} style={{ margin: 0 }}>
      Courses Management
    </Title>
  </Col>

  <Col>
    <Button
      type="primary"
      icon={<PlusOutlined />}
      size="middle"
      onClick={handleCreateNewCourse}
    >
      Create New Course
    </Button>
  </Col>
</Row>


        {/* Controls Row */}
        <Row justify="space-between" align="middle">
          <Col >
            <Tabs activeKey={activeTab} onChange={handleTabChange}>
              <TabPane 
                tab={
                  <span>
                    All Courses
                    <span style={{ marginLeft: "8px", fontSize: "12px", color: "#666" }}>
                      {activeTab === "all" ? `(${pagination.totalCount})` : ""}
                    </span>
                  </span>
                } 
                key="all"
              />
              <TabPane 
                tab={
                  <span>
                    Published
                    <span style={{ marginLeft: "8px", fontSize: "12px", color: "#666" }}>
                      {activeTab === "published" ? `(${pagination.totalCount})` : ""}
                    </span>
                  </span>
                } 
                key="published"
              />
              <TabPane 
                tab={
                  <span>
                    Draft
                    <span style={{ marginLeft: "8px", fontSize: "12px", color: "#666" }}>
                      {activeTab === "draft" ? `(${pagination.totalCount})` : ""}
                    </span>
                  </span>
                } 
                key="draft"
              />
            </Tabs>
          </Col>
          <Col >
            <Space>
              <Text strong>Sort by:</Text>
              <Select
                value={pagination.orderByLatest ? "latest" : "oldest"}
                style={{ width: 150 }}
                onChange={onSortChange}
                suffixIcon={pagination.orderByLatest ? <SortDescendingOutlined /> : <SortAscendingOutlined />}
              >
                <Option value="latest">Latest First</Option>
                <Option value="oldest">Oldest First</Option>
              </Select>
            </Space>
          </Col>
        </Row>

        {/* Courses List */}
        {courses.length > 0 ? (
          <>
            <div style={{ marginBottom: "8px" }}>
              <Text type="secondary">
                Showing {getTabDisplayText()} • {pagination.totalCount} total
              </Text>
            </div>
<List
          grid={{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 3 }}
          dataSource={courses}
          renderItem={(course) => {
             const linkedInUrl = getLinkedInUrl(course);
                const authorName = getAuthorName(course);
             return  (
                          <List.Item key={course.id}>
      <Card
  style={{
    height: "100%",
    minHeight: 320, // Slightly increased to give breathing room
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    transition: "all 0.3s ease",
    position: "relative",
    overflow: "hidden"
  }}
  hoverable
onClick={(e) => {
    e.stopPropagation();
    handleCourseCardClick(course);
  }}
  bodyStyle={{
    padding: "16px",
    flex: 1, // This allows the body to fill the card
    display: "flex",
    flexDirection: "column"
  }}
>
  {/* CLICKABLE PRICE/FREE BANNER */}
  <div 
    onClick={(e) => openPriceModal(e, course)}
    style={{
      position: "absolute",
      top: 15,
      right: -35,
      background: course.isPaid ? "#13c2c2" : "#52c41a", 
      color: "white",
      padding: "2px 40px",
      transform: "rotate(45deg)",
      fontSize: "12px",
      fontWeight: "bold",
      zIndex: 10,
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      textAlign: "center",
      width: "120px",
      cursor: "pointer"
    }}
  >
    {course.isPaid ? (
      `${course.pricing?.currency === "USD" ? "$" : (course.pricing?.currency || "$")}${course.pricing?.price || 0}`
    ) : (
      "FREE"
    )}
  </div>

  {/* Main Content Wrapper */}
  <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
    <Space direction="vertical" size="middle" style={{ width: "100%", flex: 1 }}>
      
      {/* 1. Status and Title (Fixed Height) */}
      <div style={{ display: "flex", flexDirection: "column", gap: "8px", alignItems: "flex-start", minHeight: "80px" }}>
        <Tag 
          color={course.isPublished ? "green" : "orange"} 
          icon={course.isPublished ? <EyeOutlined /> : <EditOutlined />}
          style={{ margin: 0 }}
        >
          {course.isPublished ? "Published" : "Draft"}
        </Tag>
        
    <Title
  level={4}
  style={{
    margin: 0,
    paddingRight: 45, 
    fontSize: "16px",
    lineHeight: "22px",
    height: "44px", // Fixed 2-line height
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical"
  }}
>
  {course.title}
  
  {/* Add this expert tag code */}
  {course.hasActiveExpertSupport && (
    <span style={{ 
      marginLeft: '8px', 
      fontSize: '11px', 
      color: '#faad14', 
      display: 'inline-flex', 
      alignItems: 'center',
      verticalAlign: 'middle',
      fontWeight: 'normal',
      background: '#fffbe6',
      padding: '2px 6px',
      borderRadius: '4px',
      border: '1px solid #ffe58f'
    }}>
      <StarFilled style={{ marginRight: '4px' }} />
      Expert Support
    </span>
  )}
</Title>
      </div>

        {/* Author Information */}
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <Avatar size="small" icon={<UserOutlined />} />
                          {authorName ? (
                            <Popover
                              content={
                                <div style={{ padding: '4px' }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <Text style={{ fontSize: "16px" }}>
                                      {authorName}
                                    </Text>
                                    {linkedInUrl && (
                                      <a 
                                        href={linkedInUrl} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        onClick={(e) => e.stopPropagation()}
                                        style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          width: '24px',
                                          height: '24px',
                                          borderRadius: '4px',
                                          backgroundColor: '#0077B5',
                                          color: 'white',
                                          textDecoration: 'none',
                                        }}
                                      >
                                        <LinkedinOutlined style={{ fontSize: '14px' }} />
                                      </a>
                                    )}
                                  </div>
                                </div>
                              }
                              title="Author Information"
                              trigger="click"
                            >
                              <Text 
                                type="secondary" 
                                style={{ 
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  textDecorationStyle: "dotted",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                {authorName}
                              </Text>
                            </Popover>
                          ) : (
                            <Text type="secondary" style={{ fontSize: "13px" }}>
                              No author available
                            </Text>
                          )}
                        </div>


      {/* 3. Description Section (Fills remaining space) */}
      <div style={{ flex: 1 }}>
        {course.description ? (
          <div style={{ fontSize: '14px', color: '#666' }}>
            <div style={{
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: expandedCourseId === course.id ? "unset" : 3, // Shows 3 lines for better consistency
                WebkitBoxOrient: "vertical",
                minHeight: "63px" // Ensures space is taken even if description is 1 line
              }}
            >
              {course.description}
            </div>
            {course.description.length > 70 && (
              <Button
                type="link"
                size="small"
                style={{ padding: 0, height: 'auto' }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setExpandedCourseId(expandedCourseId === course.id ? null : course.id);
                }}
              >
                {expandedCourseId === course.id ? "See less" : "See more"}
              </Button>
            )}
          </div>
        ) : (
          <div style={{ minHeight: "63px" }} /> // Placeholder to keep layout even
        )}
      </div>
    </Space>

    {/* 4. Metadata (Pinned to bottom) */}
<div
  style={{
    borderTop: '1px solid #f0f0f0',
    paddingTop: '12px',
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap'
  }}
>
  <Text type="secondary" style={{ fontSize: '12px' }}>
    Created: {formatDate(course.createdOn)}
  </Text>

  <Text type="secondary" style={{ fontSize: '12px' }}>
    Updated: {formatDate(course.lastModifiedOn)}
  </Text>

  <Text type="secondary" style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
    <ClockCircleOutlined />
    {formatTime(course.estimatedTime)}
  </Text>
</div>

  </div>
</Card>
            </List.Item>
             ) 

          }}
        />

            {/* PAGINATION - Now correct for all tabs */}
            {pagination.totalCount > 0 && (
              <Row justify="space-between" align="middle" style={{ marginTop: "24px", padding: "16px", backgroundColor: "#fafafa", borderRadius: "8px" }}>
                <Col>
                 
                </Col>
                <Col>
                  <Pagination
                    hideOnSinglePage={false}
                    current={pagination.currentPage}
                    pageSize={pagination.pageSize}
                    total={pagination.totalCount}
                    onChange={onPageChange}
                    onShowSizeChange={onPageChange}
                    showSizeChanger
                    pageSizeOptions={['6', '9', '12', '18', '24']}
                  />
                </Col>
              </Row>
            )}
          </>
        ) : (
          /* Empty State - No courses in current tab */
          <Card>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <Space direction="vertical" size="small" align="center">
                  <Text type="secondary">
                    {activeTab === "draft" 
                      ? "No draft courses found" 
                      : activeTab === "published" 
                      ? "No published courses found" 
                      : "No courses available"}
                  </Text>
                  {activeTab === "all" && (
                    <Text type="secondary">
                      Start by creating your first course
                    </Text>
                  )}
                </Space>
              }
            >
              <Button
                type="primary"
                icon={<PlusOutlined />}
                size="large"
                onClick={handleCreateNewCourse}
              >
                Create New Course
              </Button>
            </Empty>
          </Card>
        )}
      </Space>
          {/* PRICE DETAIL MODAL */}
      <Modal
        title="Pricing & Access Information"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[<Button key="close" type="primary" onClick={() => setIsModalVisible(false)}>Got it</Button>]}
      >
        {selectedPriceData && (
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Price">
              <Text strong type="success" style={{ fontSize: '16px' }}>
                {selectedPriceData.pricing?.currency} {selectedPriceData.pricing?.price}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="Access Duration">
              {formatDuration(selectedPriceData.pricing?.accessDurationDays)}
            </Descriptions.Item>
     
          </Descriptions>
        )}
      </Modal>
    </div>
  );
};

export default CoursesList;